import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import DropdownField from '../fields/DropdownField';
import AsyncDropdownField from './AsyncDropdownField';
import ValidatableField from './ValidatableField';
import { toUI } from '../../utility/mapStaticData';
import { clientRendererCollapsible, clientRenderer } from '../client/ClientView';

import './ClientField.css';

const SEARCH_TYPES = [
  'Bloomberg',
  'GCID',
  'Name',
  'ISB',
  'OMR',
  'PPQ',
  'Kondor'
];
const DEFAULT_SEARCH_TYPE = 'Name';

class ClientFieldComponent extends ValidatableField {
  constructor(props) {
    super(props);

    this.state.value = props.value;
    this.state.searchType = DEFAULT_SEARCH_TYPE;
  }

  static get propTypes() {
    return {
      name: PropTypes.string,
      value: PropTypes.any,
      editing: PropTypes.bool,
      onChange: PropTypes.func,
      required: PropTypes.bool,
      recentlyUsed: PropTypes.array,
      onFetchClients: PropTypes.func.isRequired,
      validationMessage: PropTypes.string,
      mapFn: PropTypes.func.isRequired,
      className: PropTypes.string,
      filterField: PropTypes.bool,
      toolTip: PropTypes.string
    };
  }

  static get defaultProps() {
    return {
      validationMessage: 'Please choose a Client',
      mapFn: toUI.client
    };
  }

  componentWillReceiveProps(props) {
    if (this.props.value !== props.value) {
      this.setState({ value: props.value }, () => this.validate());
    }
  }

  onChangeSearchType(value) {
    this.setState({ searchType: value });
  }

  onChange(value) {
    const { onChange } = this.props;

    this.setState({ value }, () => {
      if (this.validate()) {
        onChange(value);
      }
    });
  }

  validate() {
    const { required } = this.props;
    const { value } = this.state;

    if (required && !value) {
      this.setValid(false);
      return false;
    }

    this.setValid(true);
    return true;
  }

  onFetchClients(value) {
    const { onFetchClients } = this.props;
    const { searchType } = this.state;
    return onFetchClients(value, searchType);
  }

  showLabel() {
    const { mapFn, editing, filterField } = this.props;
    const { defaultValue } = this.state;
    const value = (mapFn && defaultValue) ? mapFn(defaultValue).value : undefined;
    return !filterField && (!editing || !!value);
  }

  render() {
    const { name, editing, required, recentlyUsed, mapFn, className, filterField, toolTip } = this.props;
    const { value, searchType } = this.state;

    return (
      <div className={classnames(className, 'ClientField', { 'not-editing': !editing })}>
        <div className="FieldsContainer-group">
          {editing && <DropdownField
            name="client-search-type"
            label=""
            showLabel=""
            onChange={updatedValue => this.onChangeSearchType(updatedValue)}
            value={searchType}
            required
            editing={editing}
            possibleValues={SEARCH_TYPES}
            mapFn={v => ({ label: v, value: v })}
            className="search-type"
            validationMessage={null}
          />
          }
          <AsyncDropdownField
            name={name}
            label="Client"
            className="search-client"
            editing={editing}
            recentlyUsed={recentlyUsed}
            required={required}
            value={value}
            fetchAsyncData={input => this.onFetchClients(input)}
            mapFn={mapFn}
            onChange={newValue => this.onChange(newValue)}
            renderer={clientRendererCollapsible}
            optionRenderer={clientRenderer}
            validationMessage={null}
            filterField={filterField}
            toolTip={toolTip}
          />
        </div>
        {this.renderMessage()}
      </div>
    );
  }
}

export default ClientFieldComponent;



// WEBPACK FOOTER //
// ./src/recordDetail/fields/ClientField.js